<template>
  <div class="w-full max-w-2xl mx-auto px-4 pt-8 pb-4">
    <Combobox as="div" class="relative" @update:modelValue="onSelect">
      <div class="relative">
        <SearchIcon class="pointer-events-none absolute top-3.5 left-4 h-5 w-5 text-gray-400" aria-hidden="true" />
        <ComboboxInput 
          class="h-12 w-full border-0 bg-white pl-11 pr-4 text-gray-800 placeholder-gray-400 focus:ring-2 focus:ring-indigo-500 sm:text-sm rounded-xl shadow-lg" 
          placeholder="Start typing an address..." 
          @change="query = $event.target.value" 
        />
      </div>

      <ComboboxOptions 
        v-if="resultList.length > 0" 
        class="absolute z-10 mt-2 w-full max-h-72 overflow-y-auto py-2 text-sm text-gray-800 bg-white rounded-xl shadow-2xl ring-1 ring-black ring-opacity-5"
      >
        <ComboboxOption v-for="item in resultList" :key="item.pid" :value="item" as="template" v-slot="{ active }">
          <li
            :class="['cursor-pointer select-none px-4 py-2', active && 'bg-indigo-600 text-white']"
            v-html="item.highlight.sla">
          </li>
        </ComboboxOption>
      </ComboboxOptions>
    </Combobox>
  </div>
</template>
<script>
import { ref } from 'vue'
import { SearchIcon } from '@heroicons/vue/solid'
import {
  Combobox,
  ComboboxInput,
  ComboboxOptions,
  ComboboxOption,
} from '@headlessui/vue'

export default {
  components: {
    Combobox,
    ComboboxInput,
    ComboboxOptions,
    ComboboxOption,
    SearchIcon,
  },
  data() {
    return {
      resultList: [],
      loading: false,
      debounceTimer: null,
    }
  },
  watch: {
    query(newQuery) {
      // Clear previous timer
      if (this.debounceTimer) {
        clearTimeout(this.debounceTimer);
      }
      
      // Clear results if query is too short
      if (newQuery.length <= 2) {
        this.resultList = [];
        return;
      }
      
      // Set new timer for debounced search
      this.debounceTimer = setTimeout(() => {
        this.loading = true;
        this.resultList = [];
        this.getResultList();
      }, 300); // Wait 300ms after user stops typing
    },
  },
  methods: {
    onSelect(selectedItem) {
      // Clear debounce timer on selection
      if (this.debounceTimer) {
        clearTimeout(this.debounceTimer);
      }
      this.resultList = [];
      this.getAddressItem(selectedItem.pid);
    },
    getAddressItem(pid) {
      return fetch('https://au-address.slj.me/addresses/' + pid, {
        method: 'get',
        headers: {
          'content-type': 'application/json'
        }
      })
      .then(res => {
        // a non-200 response code
        if (!res.ok) {
          // create error instance with HTTP status text
          const error = new Error(res.statusText);
          error.json = res.json();
          throw error;
        }
        return res.json();
      })
      .then(json => {
        this.$emit('select', json);
      })
    },
    getResultList() {
        this.loading = true
        return fetch('https://au-address.slj.me/addresses?' + new URLSearchParams({
          q: this.query,
        }), {
          method: 'get',
          headers: {
            'content-type': 'application/json'
          }
        })
          .then(res => {
            // a non-200 response code
            if (!res.ok) {
              // create error instance with HTTP status text
              const error = new Error(res.statusText);
              error.json = res.json();
              throw error;
            }
            return res.json();
          })
          .then(json => {
            this.resultList = json
          })
          /*.catch(err => {
             // handle the error
          })*/
          .then(() => {
            this.loading = false
          });
    },
  },
  beforeUnmount() {
    // Clean up timer on component destroy
    if (this.debounceTimer) {
      clearTimeout(this.debounceTimer);
    }
  },
  setup() {
    const query = ref('')
    return {
      query,
    }
  },
}
</script>
<style scoped>
li em {
  font-weight: bolder;
}
</style>
